import {defineStore} from "pinia";

export const useAuctionStore = defineStore('auctions', {
    state: () => ({
        auctions: null
    }),
    actions: {
        // since we rely on `this`, we cannot use an arrow function
        setAuctions(auctions) {
            this.auctions = auctions
        },
        updateAuction() {
            // TODO: Add some logic to only update if the auction is being followed.
            axios.get(route('deal.followed')).then(response => {
                this.setAuctions(response.data);
            });
        }

    },
})
